import { useMutation, useQueryClient } from "@tanstack/react-query";
import { saveJustifications } from "@/api/endpoints/riskAnalysis";
import { queryKeys } from "@/lib/queryClient";
import type {
  SaveJustificationsRequest,
  SaveJustificationsResponse,
} from "@/types/risk-analysis";

export function useSaveJustifications() {
  const queryClient = useQueryClient();
  return useMutation<
    SaveJustificationsResponse,
    Error,
    SaveJustificationsRequest
  >({
    mutationFn: saveJustifications,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.riskAnalysis.bySession(variables.session_id),
      });
    },
  });
}
